import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {MedicalRecordSportSaveComponent} from './medical-record-sport-save.component';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {CreateUpdateDefaultModule} from '../../../../../../core/component/create-update-default/create-update-default.module';
import {MedicalRecordSportSaveFormModule} from '../medical-record-sport-save-form/medical-record-sport-save-form.module';
import {DialogModule} from '../../../../../../common/dialog/dialog.module';
import {LoadingModule} from '../../../../../../../components/common/loading/loading.module';
import {ButtonModule} from '../../../../../../core/component/button/button.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        CardModule,
        CreateUpdateDefaultModule,
        MedicalRecordSportSaveFormModule,
        DialogModule,
        LoadingModule,
        ButtonModule,
    ],
    declarations: [
        MedicalRecordSportSaveComponent,
    ],
    exports: [
        MedicalRecordSportSaveComponent
    ],
})
export class MedicalRecordSportSaveModule {
}
